import React from "react";

//PODS
//--ADMINISTRATOR
import HVSAdminLoginControl from "./administration/HVSLoginForm/loginControl";

//--ADMIN
import PodcastsAdmin from "./podCasts/admin/files/controller";
import MapAdmin from "./map/admin/files/controller";
import PdfLibraryAdmin from "./pdfLibrary/admin/podRouter";
import PhotoAndVideoGalleryAdmin from "./photoAndVideoGallery/admin/podRouter";
import CalendarAdmin from "./calendar/admin//podRouter";
import StyleConfig from "./styleConfig/files/podRouter";

//--FRONTEND
import PodcastsFrontEnd from "./podCasts/frontEnd/files/controller";
import MapFrontEnd from "./map/frontEnd/files/controller";
import PdfLibraryFrontEnd from "./pdfLibrary/frontEnd/files/viewer";
import PhotoAndVideoGalleryFrontEnd from "./photoAndVideoGallery/frontEnd/files/podHandler";
import CalendarFrontEnd from "./calendar/frontEnd/podRouter";

//--SEGMENTED MENUS
import PDFLibrarySegmentedMenu from "./pdfLibrary/admin/files/segmentedMenu";

function EnvironmentPodsMap(props) {
    //Access from internally - NOT FROM PAGE VIEWER
    return (
        <div>
            {/* ADMIN */}
            {props.podCode == "loginForm" && <HVSAdminLoginControl />}
            {props.podCode == "CPOD_PODCASTS_ADMIN" && <PodcastsAdmin />}
            {props.podCode == "CPOD_MAP_ADMIN" && <MapAdmin />}
            {props.podCode == "CPOD_PDFLIBRARY_ADMIN" && <PdfLibraryAdmin />}
            {props.podCode == "CPOD_PHOTOANDVIDEOGALLERY_ADMIN" && <PhotoAndVideoGalleryAdmin />}
            {props.podCode == "CPOD_CALENDAR_ADMIN" && <CalendarAdmin />}
            {props.podCode == "STYLINGCONFIG" && <StyleConfig />}

            {/* FRONTEND */}
        </div>
    );
}

export function EnvironmentPodsMap_PageViewer(props) {
    //Access from Page Viewer
    return (
        <div>
            {props.podCode == "CPOD_PODCASTS_FREND" && <PodcastsFrontEnd />}
            {props.podCode == "CPOD_MAP_FREND" && <MapFrontEnd />}
            {props.podCode == "CPOD_PDFLIBRARY_FREND" && <PdfLibraryFrontEnd addInfo={props.addInfo} />}
            {props.podCode == "CPOD_PHOTOANDVIDEOGALLERY_FREND" && <PhotoAndVideoGalleryFrontEnd />}
            {props.podCode == "CPOD_CALENDAR_FREND" && <CalendarFrontEnd />}
            {/* {props.podCode == "CPOD_PHOTOGALLERY_FEND" && <PhotoGalleryPodViews podCodeExtra={props.podCodeExtra} addInfo={props.addInfo} />} */}
        </div>
    );
}

export function SegmentedMenus(code) {
    return <div>{code == "CPOD_PDFLIBRARY_FREND_SEGMENTED" && <PDFLibrarySegmentedMenu />}</div>;
}

export default EnvironmentPodsMap;
